import { render, staticRenderFns } from "./ShareBanner.vue?vue&type=template&id=408c7cf2&scoped=true&"
import script from "./ShareBanner.vue?vue&type=script&lang=ts&"
export * from "./ShareBanner.vue?vue&type=script&lang=ts&"
import style0 from "./ShareBanner.vue?vue&type=style&index=0&id=408c7cf2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408c7cf2",
  null
  
)

export default component.exports